/** @file The page origin for client setup snippets ('' where there is no location, e.g. server rendering). */

/** `https://pose2d.zilo-game.dev` in production, the Vite origin in dev. */
export function pageOrigin(): string {
  return (globalThis as { location?: { origin?: string } }).location?.origin ?? '';
}
